import { derived, writable } from 'svelte/store';
import { Piece } from '../data/piece.enum';
const INITIAL_STATE = {
    turn: 0,
    board: [
        [null, null, null, null],
        [null, null, null, null],
        [null, null, null, null],
        [null, null, null, null]
    ],
    piecesLeft: Object.values(Piece),
    pieceSelected: null,
    finished: false
};
let _player;
function initGameState() {
    const { subscribe, set, update } = writable(INITIAL_STATE);
    return {
        subscribe,
        set,
        restart: () => set(INITIAL_STATE),
        selectPiece: (piece) => update((state) => (Object.assign(Object.assign({}, state), { pieceSelected: piece, piecesLeft: state.piecesLeft.filter((p) => p !== piece), turn: state.turn + 1 }))),
        playPiece: (x, y) => update((state) => (Object.assign(Object.assign({}, state), { board: Object.assign([...state.board], {
                [x]: Object.assign([...state.board[x]], {
                    [y]: state.pieceSelected
                })
            }), pieceSelected: null }))),
        finish: () => update((state) => (Object.assign(Object.assign({}, state), { finished: true })))
    };
}
export const gameState = initGameState();
export const setPlayer = (player) => (_player = player);
export const getPlayer = () => _player;
// When first player joins, the game state is set before _player is set, causing $ownTurn to be false
// when the second player joins the state is broadcasted, also updating ownTurn
export const ownTurn = derived(gameState, ({ turn }) => turn % 2 === _player);
export const board = derived(gameState, ({ board }) => board);
export const piecesLeft = derived(gameState, ({ piecesLeft }) => piecesLeft);
export const pieceSelected = derived(gameState, ({ pieceSelected }) => pieceSelected);
export const finished = derived(gameState, ({ finished }) => finished);
